import { PhoneInput } from '@/components/ui/phone-input';
import { IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED } from '@/features/flags/legacy-flags';
import { ACCENT_VALUES, accentMessages } from '@/features/shadowHeidi/research-options';
import { useQueryInputSupportedLanguages } from '@/hooks/query/useQuerySupportedLanguages';
import { getLocalizedLanguageName } from '@/utils/languageSearch';
import {
  type PatientContextFieldsHost,
  type PatientContextPhoneInputProps,
} from '@heidi/patients';

/** Binds the form-field surface to the app implementations it renders. */
export function usePatientContextFieldsHost(): PatientContextFieldsHost {
  return {
    PhoneInput,
    isAutoExtractEnabled: IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED,
    accentValues: ACCENT_VALUES,
    accentMessages,
    useSupportedLanguages: useQueryInputSupportedLanguages,
    getLocalizedLanguageName,
  };
}

export type { PatientContextPhoneInputProps };
